/* ✅ This file is not generated and CAN be modified  */

/* 
	Must stay in sync with 
	fusion-design-system/src/tokens/js/variables/supplementary/breakpoints.ts
*/

/* DS-23: TODO - Remove this */

export const BREAKPOINTS = {
    "sm-only": "(min-width: 360px) and (max-width: 480px)",
    "sm-n-above": "(min-width: 480px)",
    "sm-n-below": "(max-width: 479px)",

    "md-only": "(min-width: 480px) and (max-width: 768px)",
    "md-n-above": "(min-width: 768px)",
    "md-n-below": "(max-width: 767px)",

    "lg-only": "(min-width: 768px) and (max-width: 1024px)",
    "lg-n-above": "(min-width: 1024px)",
    "lg-n-below": "(max-width: 1023px)",

    "xl-only": "(min-width: 1024px) and (max-width: 1440px)",
    "xl-n-above": "(min-width: 1440px)",
    "xl-n-below": "(max-width: 1439px)",

    "xxl-only": "(min-width: 1440px) and (max-width: 1920px)",
    "xxl-n-above": "(min-width: 1920px)",
    "xxl-n-below": "(max-width: 1919px)",
};
